<template>
  <div class="invite-content">
    <div class="invite-item" v-for="item in list" :key="item.id">
      <div class="invite-staff" v-if="!isVisitor">员工: {{item.currentName}}</div>
      <div class="invite-item-top" :class="{visitor: isVisitor}">      
        <div class="avatar">
          <van-image round width="48" height="48" :src="guest" />
        </div>
        <div class="content">
          <div class="name-row ellipsis-1">
            <span class="name">{{item.name}}</span>
            <span class="post">{{item.post}}</span>
          </div>
          <div class="company ellipsis-1">{{item.corporateName}}</div>
          <div class="btn-area">
            <!-- <div class="btn primary" v-if="subjectType == 'ACTOR'" @click="onDistribute(item)">分配员工</div> -->
            <div class="btn" @click="onDelete(item)">删除</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import guest from '@/assets/guest_default.png'
  import { mapGetters} from 'vuex'

  export default {
    props: {
      list: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        guest
      }
    },
    computed: {
      ...mapGetters(['languageType', 'subjectType']),
      isVisitor() {
        return this.subjectType === 'VISITOR'
      }
    },
    methods: {
      onDelete(item) {
        this.$Dialog.confirm({
          confirmButtonColor: "#163ccc",
          message: "确定要删除吗？请确认。"
        }).then(() => {
          this.$emit('delete', item)
        })
        .catch(() => {})
      },
      onDistribute(item) {
        const query = this.$route.query
        this.$router.push({
          path: '/invite/staff',
          query: {
            ...query,
            id: item.id,
            languageType: this.languageType
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

.invite-content {
  width: 100%;
  padding-bottom: 30px;
  box-sizing: border-box;
  overflow: hidden;
  }
  .invite-item {
    margin-bottom: 8px;
  }
  .invite-staff {
    padding: 12px 16px 0;
    box-sizing: border-box;
    background: #ffffff;
    font-size: 12px;
    color: rgba(0, 0, 0, .5);
    text-align: right;
  }
  .invite-item-top {
    display: flex;
    padding: 0 16px 16px;
    box-sizing: border-box;
    background: #ffffff;
    &.visitor {
      padding-top: 16px;
    }
  }
  .avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
  }
  .content {
    flex: 1;
    padding-left: 16px;
    overflow: hidden;
  }
  .name-row {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .name {
      font-weight: 400;
      font-size: 16px;
      color: #140F26;
      margin-right: 6px;
      white-space: pre-wrap;
    }
    .post{
      font-weight: 300;
      font-size: 13px;
      color: #6E7580;
      white-space: pre-wrap;
      vertical-align: middle;
    }
  }
  .company {
    font-size: 14px;
    color: #6E7580;
    margin-top: 4px;
  }
  .sure-row {
    font-size: 12px;
    margin-top: 8px;
    font-weight: 400;
    .primary {
      color: #163ccc;
    }
  }
  .btn-area {
    display: flex;
    flex-direction: row-reverse;
    padding-top: 24.5px;
    .btn {
      padding: 4px 16px;
      font-weight: 400;
      font-size: 12px;
      color: #163ccc;
      border-radius: 13px;
      border: 1px solid #163ccc;
      &.primary {
        color: #FFFFFF;
        border: none;
        background: linear-gradient(142deg, #163ccc 0%, #973eff 100%);
        margin-left: 12px;
      }
    }
  }
</style>
